import { PoiInfo, PoiPosts, PoiRelated } from 'shared/models';
import { atom, PrimitiveAtom } from 'jotai';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type PoiInfoStore = { [key: string]: Promise<PoiInfo> };
type PoiPostsStore = { [key: string]: Promise<PoiPosts> | PoiPosts };
type PoiRelatedStore = { [key: string]: Promise<PoiRelated> };

const poiInfoPendingQueue: any[] = [];
const poiPostPendingQueue: any[] = [];
const poiRelatedPendingQueue: any[] = [];

export const $PoiInfoStore: PrimitiveAtom<PoiInfoStore> = atom<PoiInfoStore>({});
export const $PoiPostStore: PrimitiveAtom<PoiPostsStore> = atom<PoiPostsStore>({});
export const $PoiRelatedStore: PrimitiveAtom<PoiRelatedStore> = atom<PoiRelatedStore>({});

export const $PoiInfo = safeAtomFamily((poiId: string) => {
  const a = atom(
    (get) => {
      return (
        get($PoiInfoStore)[poiId] ||
        new Promise((r) => {
          poiInfoPendingQueue.push(r);
        })
      );
    },
    (get, set, args: any) => {
      const old = get($PoiInfoStore);

      set($PoiInfoStore, { ...old, [poiId]: args });

      // required，finish all pending suspense boundary
      poiInfoPendingQueue.forEach((r) => r());
    },
  );
  a.debugLabel = `$PoiInfo+${poiId}`;
  return a;
});

export const $PoiPost = safeAtomFamily((poiId: string) => {
  const a = atom(
    (get) => {
      return (
        get($PoiPostStore)[poiId] ||
        new Promise((r) => {
          poiPostPendingQueue.push(r);
        })
      );
    },
    (get, set, args: any) => {
      const old = get($PoiPostStore);

      set($PoiPostStore, { ...old, [poiId]: args });
    },
  );
  a.debugLabel = `$PoiPost+${poiId}`;
  return a;
});

export const $PoiPostLoadmore = safeAtomFamily((poiId: string) => {
  const a = atom(null, async (get, set, input: PoiPosts) => {
    const old = get($PoiPostStore);
    const posts = await old[poiId];

    if (posts) {
      set($PoiPostStore, {
        ...old,
        [poiId]: {
          hasMore: input.hasMore,
          sessionImprId: input.sessionImprId,
          items: [...posts.items, ...input.items],
        } as PoiPosts,
      });
    }
  });
  a.debugLabel = `$PoiPostLoadmore+${poiId}`;
  return a;
});

export const $PoiRelated = safeAtomFamily((poiId: string) => {
  const a = atom(
    (get) => {
      return (
        get($PoiRelatedStore)[poiId] ||
        new Promise((r) => {
          poiRelatedPendingQueue.push(r);
        })
      );
    },
    (get, set, args: any) => {
      const old = get($PoiRelatedStore);

      set($PoiRelatedStore, { ...old, [poiId]: args });

      // required，finish all pending suspense boundary
      poiRelatedPendingQueue.forEach((r) => r());
    },
  );
  a.debugLabel = `$PoiRelated+${poiId}`;
  return a;
});
